var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FAF5F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.3251C21.8807 19.3251 23 18.2058 23 16.8251L23 9.50795C23 8.12223 22.2115 7 21.238 7H10.762C9.78844 7 9 8.12223 9 9.50795V16.8251C9 18.2058 10.1189 19.3251 11.4996 19.3251C12.8872 19.3251 14.4316 19.3251 14.9304 19.3251L17.289 22.1488C17.5946 22.5147 18.1844 22.3952 18.3234 21.9391L19.1202 19.3251H20.5Z",
    fill: "#A97752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 20.629C5.89543 20.629 5 19.7335 5.00001 18.629L5.00002 12.9593C5.00002 11.8767 5.67584 11 6.51031 11H15.4897C16.3242 11 17 11.8767 17 12.9593V18.629C17 19.7335 16.1047 20.629 15.0001 20.629C13.7759 20.629 12.3616 20.629 11.9168 20.629L10.4016 22.429C10.0619 22.8326 9.40415 22.6328 9.34619 22.1085L9.18265 20.629H7.00001Z",
    fill: "#A97752",
    stroke: "#FAF5F0",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64967 15.5493C8.64967 15.1278 8.30718 14.7891 7.88941 14.7891C7.46788 14.7891 7.12915 15.1316 7.12915 15.5493C7.12915 15.9709 7.47164 16.3096 7.88941 16.3096C8.30718 16.3134 8.64967 15.9709 8.64967 15.5493Z",
    fill: "#FAF5F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6268 15.5493C11.6268 15.1278 11.2844 14.7891 10.8666 14.7891C10.4451 14.7891 10.1063 15.1316 10.1063 15.5493C10.1063 15.9709 10.4488 16.3096 10.8666 16.3096C11.2844 16.3134 11.6268 15.9709 11.6268 15.5493Z",
    fill: "#FAF5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.84 16.3096C14.2599 16.3096 14.6002 15.9692 14.6002 15.5493C14.6002 15.1295 14.2599 14.7891 13.84 14.7891C13.4201 14.7891 13.0797 15.1295 13.0797 15.5493C13.0797 15.9692 13.4201 16.3096 13.84 16.3096Z",
    fill: "#FAF5F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInquiry);
export default __webpack_public_path__ + "static/media/icon-inquiry.22401d47130532f2c8e4e23e28d1b42f.svg";
export { ForwardRef as ReactComponent };